import { createStyles, makeStyles } from "@material-ui/core";
import classnames from "classnames";
import React from "react";

import { camelize, Link, LinkProps, RelodeTheme } from "..";
import { NewMessageIcon } from "../../assets/icons";
import { MessageComposer, MessageComposerProps } from "../../features";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            contactLink: {
                marginLeft: 4,
                verticalAlign: "middle",
            },
        }),
    { name: "MessageComposerIconLink" }
);

interface InnerMessageComposerIconLinkProps {
    iconColor?:
        | "inherit"
        | "primary"
        | "secondary"
        | "action"
        | "disabled"
        | "error";
}

type MessageComposerIconLinkProps = LinkProps &
    MessageComposerProps &
    InnerMessageComposerIconLinkProps;

export const MessageComposerIconLink = (
    props: MessageComposerIconLinkProps
) => {
    const [messageComposerOpen, setMessageComposerOpen] = React.useState(false);

    const {
        id,
        className: classNameProp,
        leadId,
        leadName,
        jobId,
        jobName,
        initialRecipients,
        attachments,
        initialBodyText,
        replyMessageId,
        iconColor = "primary",
        gutterBottom = false,
        hideHighlight = true,
        title = "send a message",
        ...passthrough
    } = props;

    const classes = useStyles({});
    const dataCy = passthrough["data-cy"] ?? "messageIcon";
    const linkCy = !!dataCy ? `${dataCy}-link` : undefined;
    const iconCy = !!dataCy ? `${dataCy}-icon` : undefined;

    const linkClassNames = classnames(classes.contactLink, classNameProp);

    return (
        <>
            <Link
                id={`${id}-link`}
                className={linkClassNames}
                gutterBottom={gutterBottom}
                hideHighlight={hideHighlight}
                onClick={() => setMessageComposerOpen(true)}
                title={title}
                {...passthrough}
                data-cy={linkCy}
            >
                <NewMessageIcon data-cy={iconCy} color={iconColor} />
            </Link>

            {messageComposerOpen ? (
                <MessageComposer
                    leadName={leadName}
                    leadId={leadId}
                    jobName={jobName}
                    jobId={jobId}
                    open={messageComposerOpen}
                    initialRecipients={initialRecipients}
                    attachments={attachments}
                    initialBodyText={initialBodyText}
                    replyMessageId={replyMessageId}
                    onClose={() => setMessageComposerOpen(false)}
                />
            ) : null}
        </>
    );
};
